<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 30.293 31.156">
        <g id="Group_2822" data-name="Group 2822" transform="translate(-24 -544)">
            <circle id="Ellipse_186" data-name="Ellipse 186" cx="14" cy="14" r="14" transform="translate(24 544)"
                    fill="#cedbff"/>
            <g id="shield_1_" data-name="shield (1)" transform="translate(-1.714 548.995)">
                <g id="Group_2699" data-name="Group 2699" transform="translate(33.197 0)">
                    <g id="Group_2698" data-name="Group 2698">
                        <path id="Path_70031" data-name="Path 70031"
                              d="M55.635,5.314a1.6,1.6,0,0,0-.968-1.241L45.127.122a1.586,1.586,0,0,0-1.221,0l-9.54,3.951A1.6,1.6,0,0,0,33.4,5.314a21.177,21.177,0,0,0,.668,8.9,18.71,18.71,0,0,0,3.119,6.072,21.35,21.35,0,0,0,6.556,5.52,1.6,1.6,0,0,0,1.551,0,21.35,21.35,0,0,0,6.556-5.52,18.71,18.71,0,0,0,3.119-6.072,21.176,21.176,0,0,0,.668-8.9ZM54.238,14a18.816,18.816,0,0,1-9.317,11.148.835.835,0,0,1-.809,0A18.815,18.815,0,0,1,34.795,14a20.387,20.387,0,0,1-.644-8.573.84.84,0,0,1,.506-.65L44.2.825a.829.829,0,0,1,.639,0l9.54,3.951a.84.84,0,0,1,.506.65A20.387,20.387,0,0,1,54.238,14Z"
                              transform="translate(-33.197 0)" fill="#799cfb" stroke="#799cfb" stroke-width="0.3"/>
                        <path id="Path_70032" data-name="Path 70032"
                              d="M92.925,55.045,89.2,53.523a.381.381,0,0,0-.288.7l3.729,1.522A.588.588,0,0,1,93,56.2a15.823,15.823,0,0,1-.515,6.749,14.871,14.871,0,0,1-7.447,8.777.607.607,0,0,1-.581,0,14.871,14.871,0,0,1-7.447-8.777,15.821,15.821,0,0,1-.515-6.749.587.587,0,0,1,.36-.453l7.662-3.127a.612.612,0,0,1,.459,0l2.3.939a.381.381,0,1,0,.288-.7l-2.3-.939a1.362,1.362,0,0,0-1.034,0l-7.662,3.127a1.352,1.352,0,0,0-.825,1.044,16.613,16.613,0,0,0,.539,7.085A14.812,14.812,0,0,0,78.8,68.006a17.163,17.163,0,0,0,5.288,4.389,1.374,1.374,0,0,0,1.315,0,17.161,17.161,0,0,0,5.288-4.389,14.813,14.813,0,0,0,2.519-4.833,16.612,16.612,0,0,0,.539-7.085A1.352,1.352,0,0,0,92.925,55.045Z"
                              transform="translate(-73.426 -49.183)" fill="#799cfb" stroke="#799cfb"
                              stroke-width="0.3"/>
                        <path id="Path_70033" data-name="Path 70033"
                              d="M168.4,174.415h1.517a.984.984,0,0,0,.985-.98v-1.682a.222.222,0,0,1,.224-.219h1.7a.984.984,0,0,0,.985-.98v-1.505a.984.984,0,0,0-.985-.98h-1.7a.222.222,0,0,1-.224-.219v-1.682a.984.984,0,0,0-.985-.98H168.4a.984.984,0,0,0-.985.98v1.682a.222.222,0,0,1-.224.219h-1.7a.984.984,0,0,0-.985.98v1.505a.984.984,0,0,0,.856.972.381.381,0,1,0,.1-.755.221.221,0,0,1-.194-.217v-1.505a.222.222,0,0,1,.224-.219h1.7a.984.984,0,0,0,.985-.98v-1.682a.222.222,0,0,1,.224-.219h1.517a.222.222,0,0,1,.224.219v1.682a.984.984,0,0,0,.985.98h1.7a.222.222,0,0,1,.224.219v1.505a.222.222,0,0,1-.224.219h-1.7a.984.984,0,0,0-.985.98v1.682a.222.222,0,0,1-.224.219H168.4a.222.222,0,0,1-.224-.219v-1.682a.984.984,0,0,0-.985-.98.381.381,0,0,0,0,.761.222.222,0,0,1,.224.219v1.682A.984.984,0,0,0,168.4,174.415Z"
                              transform="translate(-157.841 -156.793)" fill="#799cfb" stroke="#799cfb"
                              stroke-width="0.3"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "IHealthCare",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
